// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__3ixu-","overlay":"Modal_overlay__2Oiz0","close":"Modal_close__1XuUK"};